import React, { memo } from 'react';
import { Stack } from '@fiverr-private/layout_components';
import { VettedByProBanner } from '@fiverr-private/seller_pages_toolbox';
import { atoms } from '@fiverr-private/theme';
import { RolePageHighlights } from '../RolePageHighlights';
import { RolePageProSubcategories } from '../RolePageProSubcategories';

interface ProSectionProps {
    sellerRoleId?: string;
}

export const ProSection: React.FC<ProSectionProps> = memo(({ sellerRoleId }: ProSectionProps) => (
    <Stack direction="column" gap="6">
        <RolePageHighlights sellerRoleId={sellerRoleId} className={atoms({ paddingY: '2' })} />
        <VettedByProBanner />
        <RolePageProSubcategories />
    </Stack>
));

ProSection.displayName = 'ProSection';
